import { ColoursObj, MainButton, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'

interface IFormEditBookingsProps {
    btnText: string
    currentUsersList: string
}

export const FormEditBookings = ({
    btnText,
    currentUsersList,
}: IFormEditBookingsProps) => {
    const nav = useNavigate()
    const onChangePage = () => {
        nav('./bookings', { relative: 'path' })
    }
    return (
        <Stack
            spacing={'16px'}
            overflow="hidden"
            textOverflow="ellipsis"
            width="100%"
        >
            <MainButton id={`edit-bookings-button`} onClick={onChangePage}>
                {btnText}
            </MainButton>
            <Typography
                id={`edit-bookings-users-list`}
                textOverflow="ellipsis"
                overflow="hidden"
                variant="bodyRegular"
                width="90vw"
                color={ColoursObj.core.primary}
            >
                {currentUsersList}
            </Typography>
        </Stack>
    )
}
